import { render, staticRenderFns } from "./comp_dpc-ImagesSliderV2.vue?vue&type=template&id=60b445e8&scoped=true"
import script from "./comp_dpc-ImagesSliderV2.vue?vue&type=script&lang=js"
export * from "./comp_dpc-ImagesSliderV2.vue?vue&type=script&lang=js"
import style0 from "./comp_dpc-ImagesSliderV2.vue?vue&type=style&index=0&id=60b445e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b445e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
